<section class="crowdctrl-standard-form-inner">
  <crowdctrl-form-layout
    [heading]="heading"
    [description]="description"
    [errorMessage]="errorMessage"
    [headingId]="headingId"
    [standalone]="standalone"
    [padHorizontal]="padHorizontal"
    [padVertical]="padVertical"
  >
    <ng-content select="[crowdctrlFormSummary]"></ng-content>
    <ng-content></ng-content>
  </crowdctrl-form-layout>
</section>
